import { Button, Grid, Typography } from '@mui/material'
import colors from '../../../colors'
import React, { useState } from 'react'
import { makeStyles } from '@mui/styles';
import { texts } from '../../../general/texts';

export const SingleBankTransfer = (props) => {

    const [isCopied, setIsCopied] = useState(false)

    const handleCopy = () => {
        setIsCopied(true)
        setTimeout(() => {
            setIsCopied(false)
        }, 2500)
    };

    const useStyles = makeStyles({
        name: {
            color: colors.darkBlue,
            fontSize: '0.8rem',
            fontFamily: 'GerberaLight'
        },
        container: {
            background: colors.cyan,
            borderRadius: '10px'
        },
        iban: {
            color: colors.darkBlue,
            paddingTop: '3%',
            fontFamily: 'GerberaLight',
            paddingLeft: 10,
            width: '250px'
        },
        button: {
            background: colors.gradientOrange,
            borderRadius: '10px',
            borderRadius: '5px',
            color: colors.white,
            fontFamily: 'GerberaBold',
            width: '64px',
            textTransform: 'none',
            "&:hover": { background: colors.gradientOrange }
        }
    })

    const classes = useStyles()

    return (
        <Grid >
            <Grid container item md={12} xs={12}>
                <Typography className={classes.name} >{props.name}</Typography>
            </Grid>
            <Grid container item md={12} xs={12} className={classes.container} >
                <Grid container item md={10} xs={10} >
                    <Typography variant='body2' className={classes.iban}>{props.iban}</Typography>
                </Grid>
                <Grid container item md={2} xs={2}>
                    <Button variant='button' onClick={() => { navigator.clipboard.writeText(props.iban); handleCopy(); }} className={classes.button}>{isCopied ? '✔' : texts["prompt-copy"]}</Button>
                </Grid>
            </Grid>
        </Grid>
    )
}
export default SingleBankTransfer